"use strict";

var listDirectives = angular.module('signatureDirective', []);

listDirectives.directive('signature', function (){

    return{
        restrict: 'E',
        scope: {
            onComplete: '&'
        },
        transclude: true,
        templateUrl: 'js/directives/templates/signature.tpl.html',
        link: function (scope, element, attrs) {
            var wrapper = document.getElementById("signature-pad");
            var canvas = wrapper.querySelector("canvas");

            // Adjust canvas coordinate space taking into account pixel ratio,
            // to make it look crisp on mobile devices.
            // This also causes canvas to be cleared.
            function resizeCanvas() {
                    var ratio =  window.devicePixelRatio || 1;
                    //console.log("Ratio " + ratio);
                    canvas.width = canvas.offsetWidth * ratio;
                    canvas.height = canvas.offsetHeight * ratio;
                    canvas.getContext("2d").scale(ratio, ratio);
            }

            window.onresize = resizeCanvas;
            resizeCanvas();
            scope.signaturePad = new SignaturePad(canvas);
        },
        controller: ['$scope', function($scope){
            $scope.error = false;
            $scope.canvasVisibile = true;

            $scope.completeSignature = function(){
                if($scope.signaturePad.isEmpty()){
                    $scope.error = true;
                    return;
                }
                $scope.error = false;

                $scope.onComplete()($scope.cropAndSave($scope));
            },

            $scope.clear = function(){
                $scope.signaturePad.clear();
            },

            $scope.cropAndSave = function($scope){
                $scope.canvasVisibile = false;
                $scope.signaturePad.removeBlanks();
                //take plain base64 string from canvas, removing "data:image/png;base64," at the start
                return $scope.signaturePad.toDataURL().split(",")[1];
            }
        }]
    };

});
